/**
 * Read the filename the server chose out of a Content-Disposition header.
 *
 * Downloads used to be named at each call site — `Closing_Stock_Template.xlsx`
 * for every business, every date, both formats — while the server's own header
 * was thrown away. The server is the only place that knows the business name
 * and the closing date, so it names the file and this reads its answer.
 *
 * `filename*` (RFC 5987) wins when present: it is the percent-encoded UTF-8
 * form and survives accents that the plain `filename` has to strip.
 *
 * NOTE: on a cross-origin API the browser hides this header unless the server
 * sends `Access-Control-Expose-Headers: Content-Disposition`. Without that this
 * returns null and callers fall back — correctly, but the name is lost.
 */
export function filenameFromContentDisposition(header) {
  if (!header || typeof header !== 'string') return null;

  // filename*=UTF-8''Caf%C3%A9%20Stock.pdf   (charset'lang'value)
  const star = header.match(/filename\*\s*=\s*([^']*)'([^']*)'([^;]+)/i);
  if (star) {
    try {
      const decoded = decodeURIComponent(star[3].trim().replace(/^"|"$/g, ''));
      if (decoded) return sanitize(decoded);
    } catch (e) {
      // Malformed percent-encoding: fall through to the plain form rather than
      // throwing inside a download the user is waiting on.
    }
  }

  const plain = header.match(/filename\s*=\s*"([^"]*)"/i) || header.match(/filename\s*=\s*([^;]+)/i);
  if (plain && plain[1] && plain[1].trim()) return sanitize(plain[1].trim());

  return null;
}

/** A server can only ever name the file — never place it. */
function sanitize(name) {
  return name.replace(/[\/]+/g, '_').replace(/^\.+/, '').trim() || null;
}

export default filenameFromContentDisposition;
